import Accessibility from './lib/accessibility';

/**
 * Runs a callback function as soon as the <body> element is available in the DOM.
 *
 * This utility is useful for executing critical scripts (like Accessibility settings)
 * that should apply before the full DOM has loaded, but after <body> exists.
 * It avoids the delay of waiting for the full DOMContentLoaded event,
 * helping reduce visual flashes (e.g., theme flicker).
 *
 * @param {Function} callback - The function to execute once <body> is present.
 */
function runWhenBodyReady(callback) {
	if (document.body) {
		callback();
	} else {
		setTimeout(() => runWhenBodyReady(callback), 1);
	}
}

// Initialize accessibility logic as early as possible
runWhenBodyReady(() => {
	new Accessibility();
});